import Vue from 'vue'
import Router from 'vue-router'

// import home from '@/components/home'
// import ztxm from '@/components/ztxm'
// import list from '@/components/list'
// import imgfontlist from '@/components/imgfontlist'
// import datefontlist from '@/components/datefontlist'
// import jnpx from '@/components/jnpx'
// import zysz from '@/components/zysz'
// import content from '@/components/content'
// import dxzn from '@/components/dxzn'
// import yzyx from '@/components/yzyx'
// import mlxy from '@/components/mlxy'
// import hdsg from '@/components/hdsg'
// import notFound from '@/components/404'
const home = () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/components/home')
const ztxm = () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/components/ztxm')
const list = () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/components/list')
const imgfontlist = () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/components/imgfontlist')
const datefontlist = () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/components/datefontlist')
const jnpx = () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/components/jnpx')
const zysz = () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/components/zysz')
const content = () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/components/content')
const dxzn = () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/components/dxzn')
const yzyx = () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/components/yzyx')
const mlxy = () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/components/mlxy')
const hdsg = () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/components/hdsg')
const imglist = () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/components/imglist')
const bxzq = () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/components/bxzq')
const danye = () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/components/danye')
const notFound = () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/components/404')


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: "/m/",
  routes: [{
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/ztxm',
      name: 'ztxm',
      component: ztxm
    },
    {
      path: '/list',
      component: list,
      children: [{
          path: 'hwlx', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'hwlx',
          component: imgfontlist
        },
        {
          path: 'ksgz',
          name: 'ksgz',
          component: datefontlist
        }, {
          path: 'zsjz',
          name: 'zsjz',
          component: datefontlist
        }, {
          path: 'xssw',
          name: 'xssw',
          component: datefontlist
        }, {
          path: 'aqjy',
          name: 'aqjy',
          component: datefontlist
        }, {
          path: 'xlzx',
          name: 'xlzx',
          component: datefontlist
        }, {
          path: 'jxzg',
          name: 'jxzg',
          component: datefontlist
        }, {
          path: 'gjnjdjs',
          name: 'gjnjdjs',
          component: datefontlist
        }, {
          path: 'tzgg',
          name: 'tzgg',
          component: datefontlist
        }, {
          path: 'mtgz',
          name: 'mtgz',
          component: datefontlist
        }, {
          path: 'djyl',
          name: 'djyl',
          component: datefontlist
        }, {
          path: 'xxgk',
          name: 'xxgk',
          component: datefontlist
        },
        {
          path: 'dxzn',
          name: 'dxzn',
          component: dxzn
        },
        {
          path: 'bgyx',
          name: 'yzyx',
          component: yzyx
        },
        {
          path: 'jnpx',
          name: 'jnpx',
          component: jnpx
        },
        {
          path: 'zysz',
          name: 'zysz',
          component: zysz
        },
        {
          path: 'mlxy',
          name: 'mlxy',
          component: mlxy
        },
        {
          path: 'jybz',
          name: 'jybz',
          component: mlxy
        },
        {
          path: 'szjy',
          name: 'szjy',
          component: imgfontlist
        }, {
          path: 'xyyw',
          name: 'xyyw',
          component: imgfontlist
        }, {
          path: 'txzj',
          name: 'txzj',
          component: imgfontlist
        }, {
          path: 'bxzq',
          name: 'bxzq',
          component: bxzq
        },{
          path: 'sxhj',
          name: 'sxhj',
          component: danye
        }, {
          path: 'jsbz',
          name: 'jsbz',
          component: imgfontlist
        },{
          path: 'xyfg',
          name: 'xyfg',
          component: imglist
        },{
          path: 'xysh',
          name: 'xysh',
          component: imgfontlist
        },{
          path: 'xyms',
          name: 'xyms',
          component: imglist
        },{
          path: 'zbhj',
          name: 'zbhj',
          component: danye
        },{
          path: 'sxbk',
          name: 'sxbk',
          component: imgfontlist
        },

        {
          path: 'content',
          name: 'pagecontent',
          component: content
        }
      ]
    }, {
      path: "/hdsg",
      name: "hdsg",
      component: hdsg
    },
    {
      path: "/404",
      name: "notFound",
      component: notFound
    }, {
      path: "*", // 此处需特别注意置于最底部
      redirect: "/404"
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js